var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOdt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ODT"
  }, /*#__PURE__*/React.createElement("g", {
    id: "File"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m302.2 0h-191.1c-18.4 0-33.4 15-33.4 33.5v445.1c0 18.5 15 33.4 33.5 33.5h335.5c18.5 0 33.4-15 33.5-33.5l-1-330.6z",
    fill: "#fca235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.2 0-.5 144.5s.5 3.5 3.5 3.5h174z",
    fill: "#3a0101"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m45.5 246.7h337.6c7.5 0 13.6 6.1 13.6 13.6v150.8c0 7.5-6.1 13.6-13.6 13.6h-337.6c-7.5 0-13.6-6.1-13.6-13.6v-150.8c0-7.5 6.1-13.6 13.6-13.6z",
    fill: "#3a0101"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96 336.6c0-12.2 3.4-21.7 10.2-28.6 6.8-6.8 16.3-10.2 28.5-10.2 12.5 0 22.1 3.3 28.8 10s10.1 16 10.1 28.1c0 8.8-1.5 15.9-4.4 21.5-2.9 5.5-7.3 10.1-12.8 13.1-5.6 3.1-12.5 4.7-20.8 4.7-8.4 0-15.4-1.3-21-4-5.7-2.8-10.4-7.3-13.5-12.8-3.4-5.7-5.1-13-5.1-21.8zm23.1.2c0 7.6 1.4 13 4.2 16.3s6.6 5 11.5 5c5 0 8.8-1.6 11.6-4.9 2.7-3.2 4.1-9 4.1-17.4 0-7.1-1.4-12.2-4.3-15.5-2.8-3.3-6.7-4.9-11.6-4.9-4.3-.1-8.5 1.7-11.2 5-2.8 3.3-4.2 8.7-4.3 16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.4 299.1h34.4c6.8 0 12.3.9 16.4 2.8 4.1 1.7 7.6 4.5 10.4 7.9 2.8 3.5 4.8 7.6 5.9 12 1.2 4.7 1.9 9.6 1.8 14.5 0 8-.9 14.2-2.7 18.6-1.7 4.2-4.3 8-7.6 11.1-2.9 2.8-6.5 4.8-10.4 5.9-4.5 1.3-9.1 1.9-13.8 2h-34.4zm23.1 17v40.9h5.7c4.8 0 8.3-.5 10.3-1.6 2.2-1.3 3.9-3.2 4.8-5.6 1.2-2.7 1.7-7 1.7-13 0-7.9-1.3-13.4-3.9-16.3s-6.9-4.4-12.9-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.2 299.1h70.4v18.5h-23.6v56.4h-23.1v-56.4h-23.6v-18.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdt);
export default __webpack_public_path__ + "static/media/odt.84554fdda4d624aa2806c1d7e8cff790.svg";
export { ForwardRef as ReactComponent };